//@flow

import React from 'react';
import {IconButton, Typography, makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';

import {useTaxInvoiceList} from '../../utils';
import {colors} from '../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';

import {ArrowForwardIos} from '@material-ui/icons';

const generateGradient = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h1 = Math.abs(hash % 360);
  const h2 = Math.abs((hash + 40) % 360);
  return `linear-gradient(135deg, hsl(${h1}, 70%, 80%) 0%, hsl(${h2}, 70%, 80%) 100%)`;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '1rem',
    background: 'white',
    borderRadius: '.75rem',
    boxShadow:
      '0px 0.5px 2px 0px rgba(96, 97, 112, 0.16), 0px 0px 1px 0px rgba(40, 41, 61, 0.08);',
  },

  title: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
  },
  item: {
    display: 'flex',
    padding: '1rem',
    borderBottom: `1px solid ${colors.grey200}`,
    textDecoration: 'none',

    '&:hover': {
      background: colors.grey200,
    },

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  data: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    gap: '1rem',
  },
  itemTitle: {
    fontWeight: 500,
    fontSize: '1rem',
    color: colors.grey800,
  },
  logo: {
    width: '3rem',
    height: '3rem',
    borderRadius: '.5rem',
    overflow: 'hidden',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
}));

export default function TaxInvoiceSettings() {
  const {providers} = useTaxInvoiceList();

  const classes = useStyles();

  return (
    <div className={classes.list}>
      {providers.map(provider => (
        <Link
          key={provider.id}
          className={classes.item}
          to={`/integrations/tax-invoice/settings/${provider.id}`}
        >
          <div className={classes.data}>
            <div
              className={classes.logo}
              style={{background: generateGradient(provider.name)}}
            />
            <Typography className={classes.itemTitle}>
              {provider.name}
            </Typography>
          </div>
          <div className={classes.options}>
            {/* <IosSwitch defaultChecked={provider.enabled} /> */}

            <IconButton>
              <ArrowForwardIos />
            </IconButton>
          </div>
        </Link>
      ))}
    </div>
  );
}
